import { TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as AssetHelpers from "../core/AssetHelpers";
import {HoverableButton, TextureButton} from "../core/Button";
import {Callback, Mix} from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import { LightsOutObjectType } from "../data/LightsOutObjectType";
import {TrashType} from "../data/TrashType";
import { GlowFilter } from "../filters/GlowFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { Button } from "./Button";
import { LightsOutObject } from "./LightsOutObject";

export class AnimatedLightsOutObject extends LightsOutObject {
    protected onSprite = this.visuals.addChild(new HLF.AnimatedSprite());
    protected spriteSheet: string | string[];
    protected frameCount: number;
    protected splitFrame?: number;
    protected loopCount: number;

    constructor(pData: {
        type: LightsOutObjectType,
        spriteSheet: string | string[],
        frames: number,
        splitFrame?: number,
        toggle?: boolean,
        loopCount?: number,
    }) {
        super(pData);
        this.spriteSheet = pData.spriteSheet;
        this.frameCount = pData.frames;
        this.splitFrame = pData.splitFrame;
        this.toggle = pData.toggle ?? false;
        this.onSprite.filters = [this.outlineFilter];
        if (pData.loopCount === undefined) {
            if (this.objectType !== "easteregg") {
                this.loopCount = -1;
            }
            else {
                this.loopCount = 1;
            }
        }
        else {
            this.loopCount = pData.loopCount;
        }
        this.update = this.update.bind(this);
        PIXI.Ticker.shared.add(this.update);
    }

    public destroy() {
        super.destroy();
        PIXI.Ticker.shared.remove(this.update);
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        super.setLayoutTexture(texture, anchorX, anchorY);
        this.onSprite?.anchor.set(anchorX, anchorY);
    }

    public onLayout() {
        super.onLayout();

        const onAnimStartFrame = 1;
        const onAnimFrameCount = this.splitFrame ?? this.frameCount;
        const fps = 10;
        const loop: boolean = this.loopCount !== 0 && this.loopCount !== 1;
        const anim = new HLF.SpriteAnimation(this.name + "-on", this.spriteSheet, onAnimFrameCount, 2, fps, loop, onAnimStartFrame);
        let c = 0;
        if (loop) {
            anim.onLoop(() => {
                c++;
                if (c < this.loopCount) {
                    //
                }
                else if (c === this.loopCount) {
                    this.onSprite.holdFrame("on", onAnimFrameCount);
                    if (!this.toggle) {
                        c = 0;
                        this.TurnOff();
                    }
                }
            });
        }
        if (this.objectType === "easteregg") {
            anim.onComplete(() => {
                if (!this.toggle) {
                    this.TurnOff();
                }
            });
        }
        this.onSprite.addAnimation("on", anim);

        if (this.splitFrame) {
            const offAnimStartFrame = this.splitFrame;
            const offAnimFrameCount = (this.frameCount - this.splitFrame) + 1;
            const anim2 = new HLF.SpriteAnimation(this.name + "-on", this.spriteSheet, offAnimFrameCount, 2, fps, false, offAnimStartFrame);
            anim2.onComplete(() => {
                TweenLite.delayedCall(1 / fps, () => {
                    this.onSprite.visible = false;
                    this.sprite.visible = true;
                });
            });
            this.onSprite.addAnimation("off", anim2);
        }
    }

    public TurnOn(pOptions: {animate: boolean} = {animate: true}): void {
        this.sprite.visible = false;
        this.onSprite.visible = true;

        if (pOptions.animate) {
            this.onSprite.play("on");
            this.onSprite.update(0);
        }
        else {
            if (this.splitFrame) {
                this.onSprite.holdFrame("on", this.splitFrame);
            }
            else {
                this.onSprite.holdFrame("on", this.frameCount);
            }
        }
        super.TurnOn(pOptions);
    }

    public TurnOff(pOptions: {animate: boolean} = {animate: true}): void {
        if (this.splitFrame) {
            this.sprite.visible = false;
            this.onSprite.visible = true;
            if (pOptions.animate) {
                this.onSprite.play("off");
            }
            else {
                this.onSprite.holdFrame("off", this.frameCount);
            }
        }
        else {
            this.onSprite.visible = false;
            this.sprite.visible = true;
        }
        super.TurnOff(pOptions);
    }

    protected update() {
        const deltaTime: number = PIXI.Ticker.shared.deltaMS / 1000;
        this.onSprite.update(deltaTime);
    }
}
